export const discountFieldValueValidator = values => {
  const { formattedValue, floatValue } = values

  if (typeof floatValue === 'number') {
    return floatValue >= 0 && floatValue <= 100
  } else {
    return formattedValue === ''
  }
}
